/*
 * @Description: 页面暂无数据的缺省提示
 */

import React from 'react';
import { Flex } from 'antd-mobile';
import './index.less';
import cx from 'classnames';
import config from 'config/Config';

const { CDN_BASE } = config;

const EmptyTips = ({
  thumb = `${CDN_BASE}/assets/imgs/default/no_data.png`, // String类型 提示图片的地址
  title = '去添加点什么吧', // String类型 提示的文字
  className = '',
  style = {}
}) => {
  return (
    <Flex direction="column" justify="center" style={style} className={cx('empty-tips', className)}>
      <img src={thumb} alt="提示图片" />
      <p>{title}</p>
    </Flex>
  );
};

export default EmptyTips;



// WEBPACK FOOTER //
// ./src/pubBiz/EmptyTips/index.js